import React from 'react';
import { isEmpty } from 'lodash';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

import Item from '../routes/Item';
import Clue from '../routes/Clue';
import { getInternalBaseUrl } from '../../common/global.js';

import styles from './RouteStop.module.scss';

export default class RouteStop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onClickStop = this.onClickStop.bind(this);

    this.onDragStopStart = this.onDragStopStart.bind(this);
    this.onDragStopOver = this.onDragStopOver.bind(this);
    this.onDropStop = this.onDropStop.bind(this);
  }

  static propTypes = {
    stopNumber: PropTypes.number,
    clue: PropTypes.object,
    item: PropTypes.object,
  };

  static defaultProps = {
    stopNumber: 0,
    clue: {},
    item: {},
  };

  onClickStop(index) {
    let s = this.props.stop;
    s.index = index;
    this.props.onClickStopFunc(s);
  }

  onDragStopStart(e, stopNumber) {
    e.dataTransfer.setData('text/plain', stopNumber - 1);
  }

  onDragStopOver(e, stopNumber) {
    e.preventDefault();
    this.props.highlightDestinationFunc(stopNumber);
  }

  onDropStop(e, category, stopNumber) {
    if (category === 'completed') {
      const from = e.dataTransfer.getData('text');
      const to = stopNumber - 1;
      this.props.onSwapCompleteFunc(from, to);
    }
  }

  renderStopInfoProviderPart(provider, clue, notes) {
    let stopNumber = this.props.stopNumber;
    if (isEmpty(provider)) return null;
    const storyboard = this.props.storyboard;

    const { id = '' } = provider;
    let providerURL = getInternalBaseUrl().providers + '?id=' + id;
    return (
      <Link
        to={providerURL}
        style={{ textDecoration: 'none', color: storyboard && !isEmpty(storyboard) ? 'inherit' : provider.enablingStoryboard ? 'red' : 'inherit' }}
        onClick={e => {
          // This has been done to stop default onClick behaviour of the Link.
          e.preventDefault();
        }}
      >
        {' '}
        <Clue
          provider={provider}
          clue={clue}
          stopNumber={stopNumber}
          notes={notes}
          stopType={this.props.stopType}
          onClickStopFunc={this.props.onClickStopFunc}
          // This has been done to update stop as no stop has an Id.
          // stopNumber is the only indication where the update has been requested.
          // This will overwrite the changes if there are concurrent actions on the same stop of a route.
        />
      </Link>
    );
  }

  renderStopInfoItemPart(item) {
    if (isEmpty(item)) return <div />;
    return <Item item={item} currencySymbol={this.props.currencySymbol} notActive={item.status !== 'active'} />;
  }

  render() {
    const provider = this.props.provider;
    const clue = this.props.clue;
    const item = this.props.item;
    const notes = this.props.notes;
    let stopNumber = this.props.stopNumber;

    let borderColor = '#52A8EF';
    let borderStyle = 'none';
    let padding = '0px';

    if (this.props.highlight === stopNumber) {
      borderColor = '#52A8EF';
      borderStyle = 'dashed';
      padding = '5px';
    }

    return (
      <div
        className={styles.root}
        draggable
        onDragStart={e => this.onDragStopStart(e, stopNumber)}
        onDragOver={e => this.onDragStopOver(e, stopNumber)}
        onDrop={e => this.onDropStop(e, 'completed', stopNumber)}
        style={{
          backgroundColor: this.props.stopType === 'payment-only' ? '#BEBEBE' : ''
        }}
      >
        <div
          className={styles.list}
          style={{
            borderColor: borderColor,
            borderStyle: borderStyle,
            padding: padding,
          }}
        >
          {this.renderStopInfoProviderPart(provider, clue, notes)}
          {this.renderStopInfoItemPart(item)}
        </div>
      </div>
    );
  }
}
